// src/components/modals/ConfirmDeleteModal.jsx
import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./ObjectExplorerModals.css";

export default function ConfirmDeleteModal({
  show,
  onClose,
  onConfirm,
  title = "Confirmar Exclusão",
  message,
  item,
}) {
  // Determine dynamic message if item is provided
  const defaultMsg = item
    ? `Tem certeza que deseja excluir ${item.isFolder ? 'a pasta' : 'o arquivo'} "${item.key}"?`
    : "Tem certeza?";

  return (
    <Modal show={show} onHide={onClose} centered className="object-modal">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="object-modal-callout">
          <p className="mb-0">{message || defaultMsg}</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Excluir
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
